// language=GraphQL
export const ALL_AVAILABILITY_STATUS_QUERY = `query Query($withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false) {
  availabilityStatus: allTravelAvailabilityStatus {
    id
    label
    status
    isDefaultStatus
    isDefaultWaitlistFallback
    tenantSettings @include(if: $withTenantSettings) {
      id
      tenant @include(if: $withTenantSettingsTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantSettingsTenantCms) {
          id
        }
        travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {
          id
          name
          description
        }
        employees @include(if: $withTenantSettingsTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          previewTravelInterestTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {
          id
          provider
        }
        redirects @include(if: $withTenantSettingsTenantRedirects) {
          id
          fromType
          fromUrl
          toType
          toUrl
        }
        onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {
          id
          enabled
          datatransMerchantId
          datatransMerchantPw
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantSettingsTenantContent) {
          id
          bookingInsuranceInfo
          co2CompensationInfo
        }
        partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {
          id
          filterCrossLinking
        }
      }
      label
      info
      switchToStatusInfo
      submitButtonLabel
    }
  }
}`

// language=GraphQL
export const SINGLE_AVAILABILITY_STATUS_QUERY = `query Query($id: ID!, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false) {
  availabilityStatus: travelAvailabilityStatus(id: $id) {
    id
    label
    status
    isDefaultStatus
    isDefaultWaitlistFallback
    tenantSettings @include(if: $withTenantSettings) {
      id
      tenant @include(if: $withTenantSettingsTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantSettingsTenantCms) {
          id
        }
        travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {
          id
          name
          description
        }
        employees @include(if: $withTenantSettingsTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          previewTravelInterestTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {
          id
          provider
        }
        redirects @include(if: $withTenantSettingsTenantRedirects) {
          id
          fromType
          fromUrl
          toType
          toUrl
        }
        onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {
          id
          enabled
          datatransMerchantId
          datatransMerchantPw
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantSettingsTenantContent) {
          id
          bookingInsuranceInfo
          co2CompensationInfo
        }
        partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {
          id
          filterCrossLinking
        }
      }
      label
      info
      switchToStatusInfo
      submitButtonLabel
    }
  }
}`

// language=GraphQL
export const CREATE_AVAILABILITY_STATUS_MUTATION = `
  mutation Mutation($input: CreateTravelAvailabilityStatusInput, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false) {
    availabilityStatus: createTravelAvailabilityStatus(input: $input) {
      id
      label
      status
      isDefaultStatus
      isDefaultWaitlistFallback
      tenantSettings @include(if: $withTenantSettings) {
        id
        tenant @include(if: $withTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
          cms @include(if: $withTenantSettingsTenantCms) {
            id
          }
          travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {
            id
            name
            description
          }
          employees @include(if: $withTenantSettingsTenantEmployees) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {
            id
            defaultInternalRecipientEmail
            internalBookingRecipientEmails
            bookingConfirmationTemplateId
            bookingConfirmationInternalTemplateId
            bookingRequestConfirmationTemplateId
            bookingWaitlistConfirmationTemplateId
            bookingWaitlistContingentCheckConfirmationTemplateId
            bookingCustomRequestTemplateId
            bookingPassportDataReminderTemplateId
            previewTravelInterestTemplateId
            contactFormTemplateId
            esimInstallationInfoTemplateId
          }
          newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {
            id
            provider
          }
          redirects @include(if: $withTenantSettingsTenantRedirects) {
            id
            fromType
            fromUrl
            toType
            toUrl
          }
          onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {
            id
            enabled
            datatransMerchantId
            datatransMerchantPw
            ratioFibuAccountNo
            infoText
            datatransThemeConfig
          }
          ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {
            id
            adressgruppe
          }
          content @include(if: $withTenantSettingsTenantContent) {
            id
            bookingInsuranceInfo
            co2CompensationInfo
          }
          partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {
            id
            filterCrossLinking
          }
        }
        label
        info
        switchToStatusInfo
        submitButtonLabel
      }
    }
  }`

// language=GraphQL
export const UPDATE_AVAILABILITY_STATUS_MUTATION = `
  mutation Mutation($input: UpdateTravelAvailabilityStatusInput, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false) {
    availabilityStatus: updateTravelAvailabilityStatus(input: $input) {
      id
      label
      status
      isDefaultStatus
      isDefaultWaitlistFallback
      tenantSettings @include(if: $withTenantSettings) {
        id
        tenant @include(if: $withTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
          cms @include(if: $withTenantSettingsTenantCms) {
            id
          }
          travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {
            id
            name
            description
          }
          employees @include(if: $withTenantSettingsTenantEmployees) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {
            id
            defaultInternalRecipientEmail
            internalBookingRecipientEmails
            bookingConfirmationTemplateId
            bookingConfirmationInternalTemplateId
            bookingRequestConfirmationTemplateId
            bookingWaitlistConfirmationTemplateId
            bookingWaitlistContingentCheckConfirmationTemplateId
            bookingCustomRequestTemplateId
            bookingPassportDataReminderTemplateId
            previewTravelInterestTemplateId
            contactFormTemplateId
            esimInstallationInfoTemplateId
          }
          newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {
            id
            provider
          }
          redirects @include(if: $withTenantSettingsTenantRedirects) {
            id
            fromType
            fromUrl
            toType
            toUrl
          }
          onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {
            id
            enabled
            datatransMerchantId
            datatransMerchantPw
            ratioFibuAccountNo
            infoText
            datatransThemeConfig
          }
          ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {
            id
            adressgruppe
          }
          content @include(if: $withTenantSettingsTenantContent) {
            id
            bookingInsuranceInfo
            co2CompensationInfo
          }
          partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {
            id
            filterCrossLinking
          }
        }
        label
        info
        switchToStatusInfo
        submitButtonLabel
      }
    }
  }`

// language=GraphQL
export const DELETE_AVAILABILITY_STATUS_MUTATION = `
  mutation Mutation($input: DeleteTravelAvailabilityStatusInput) {
    deleteTravelAvailabilityStatus(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_AVAILABILITY_STATUS_MUTATION = `
  mutation Mutation($input: DeleteTravelAvailabilityStatusInput) {
    forceDeleteTravelAvailabilityStatus(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: addTravelAvailabilityStatusTenantSettingsInput) {
    addTravelAvailabilityStatusTenantSettings(input: $input) {
      id
      tenantSettingsIds
    }
  }`

// language=GraphQL
export const REMOVE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: removeTravelAvailabilityStatusTenantSettingsInput) {
    removeTravelAvailabilityStatusTenantSettings(input: $input) {
      id
      tenantSettingsIds
    }
  }`

// language=GraphQL
export const CREATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: createTravelAvailabilityStatusTenantSettingsInput) {
    createTravelAvailabilityStatusTenantSettings(input: $input) {
      id
      tenantSettingsIds
    }
  }`

// language=GraphQL
export const DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: deleteTravelAvailabilityStatusTenantSettingsInput) {
    deleteTravelAvailabilityStatusTenantSettings(input: $input) {
      id
      tenantSettingsIds
    }
  }`

// language=GraphQL
export const UPDATE_AVAILABILITY_STATUS_TENANT_SETTINGS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelAvailabilityStatusTenantSettingsOrderInput) {
    updateTravelAvailabilityStatusTenantSettingsOrder(input: $input) {
      id
      tenantSettingsIds
    }
  }`

// language=GraphQL
export const AVAILABILITY_STATUS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravels: Boolean = false, $withRatioTravelDates: Boolean = false) {
  groupedDependents: travelAvailabilityStatusDependents(id: $id) {
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency
    }
    ratioTravelDates @include(if: $withRatioTravelDates) {
      id
      dateNo
      startDate
      endDate
      isHidden
      includesExtension
      json
    }
  }
}`
